module.exports = __webpack_public_path__ + "static/media/UniNeueHeavy.d772df50.eot";